import { gql } from "@apollo/client";

export const GET_PLANES_BUSCADOR = gql`
query GetAllPlanCuidado(
    $skip: Int
    $take: Int
    $where: PlanCuidadoFilterInput  
    $order : [PlanCuidadoSortInput!] 
) {
    allPlanCuidado(skip: $skip, take: $take, where: $where, order: $order )
    {
        items {
            idPlanCuidado
            codigoSap      
            nombre
            idComplejidadNavigation{
                descripcion
            }
            idTipoModuloNavigation {
                abreviacion
                complejidad
            }
            cotizado
        }
        totalCount
    }
}`;

export const adaptPlan = (plan) => {
  return {
    id: plan?.idPlanCuidado,
    codigoSap: plan?.codigoSap,
    programa: plan?.idTipoModuloNavigation?.abreviacion,
    nombre: plan?.nombre,
    complejidad: plan?.idComplejidadNavigation?.descripcion,
    complejidadModulo: plan?.idTipoModuloNavigation?.complejidad,
    cotizado: plan?.cotizado ? 'SI' : 'NO'
  };
};

export const adaptPlanesArray = (
planes) =>
{
  return structuredClone(planes?.allPlanCuidado?.items)?.
  map((plan) => adaptPlan(plan));
};